import React, {useState} from "react";
import VideoPlayer from "../videoPlayer/VideoPlayer";


const CoursePreview = (props) => {
    const {data} = props;
    const [preview, setPreview] = useState(props?.preview);
    const [videoURL, setVideoURL] = useState("/videos/coding.mp4");
    const [videoUrlList, setVideoUrlList] = useState(props?.preview);

    const previewList = data?.map(chapter =>
        chapter.lectureList?.filter(lecture => lecture.canBePreviewed).map(lecture => (
            <div className={"lecture align-center " +(lecture.id === preview.id && " active")} key={lecture.id}
            onClick={() => setPreview(lecture.id)}>
                <div className="left">
                    <img src="/images/card.jpg" alt="icon" width="90%"/>
                </div>
                <div className="right align-center">
                    <p>{lecture.title}</p>
                    <p >{lecture.contentSummary}</p>
                </div>

            </div>
        ))
    ).flat();

    return (
        <>
            <h4>Kurs Önizlemesi</h4>
            <VideoPlayer url={videoURL}/>
            {/*<VideoPlayer url = { [ preview.asset.videoUrl, ...videoUrlList]}/>*/}

            <div className="course-preview">
                {previewList}
            </div>

            {/*{data?.map(chapter => chapter.lectureList?.filter(lecture =>  lecture.canBePreviewed).map(lecture => <p>{lecture.title}</p>))}*/}
        </>
    );
}
export default CoursePreview;